import Grid from '../../components/Grid';
import EstadisticaService from '../../services/estadisticas_service.js';
import SedeService from '../../services/sede_service.js';
import AlertService from '../../services/alert_service.js';
import GeneralService from '../../services/general_service.js';
import ChartCard from '../../components/Cards/ChartCard.vue';
import StatsCard from '../../components/Cards/StatsCard.vue';
import DatosParametricosService from '../../services/datos_parametricos_service.js';

const alertService = new AlertService();
const generalService = new GeneralService();
const estadisticaService = new EstadisticaService();
const sedeService = new SedeService();
const datosParametricosService = new DatosParametricosService();

let _this;
let search =JSON.stringify({fechaDesde: '2023-01-01', fechaHasta: '', sede: '', idEspecialidadInternacion: '', idSubEspecialidad: ''});

export default {
	name: 'EstCama',
	components: { Grid, ChartCard, StatsCard },
	data: function() {
		return {
			titulo: 'ESTADISTICAS DE CIRUGIA',
			searchQuery: '',
			especialidades: [],
			search: JSON.parse(search),
			generalService: generalService,
			promedioCamasOcupadas: '-',
			promedioDiasInternados: '-',
			promedioDiasInternadosPorProcedimiento: [],
			rangoFecha: '-',
			diasInternadosHastaCirugia: '-',
			sedes: [],
			submited: false,
			cantidadCirugias: '-',
			cantidadInternaciones:  '-',
			subespecialidades: []
		}
	}, 
	created: function () {
		this.submited = false;
		_this = this;
		_this.getSedes();
		_this.getEstadisticasCama();
		_this.getEspecialidades();
		_this.getSubEspecialidades();
	}, 
	methods: { 
		getPromedioCamasOcupadasPorDia: function () {
			this.buscando = true;
			estadisticaService.getPromedioPorFechaCamas({fechaDesde: _this.search.fechaDesde, fechaHasta: _this.search.fechaHasta, sede: _this.search.sede, 
														idEspecialidadInternacion: _this.search.idEspecialidadInternacion, idSubEspecialidad: _this.search.idSubEspecialidad}).then(function(response) {
				_this.buscando = false;
				_this.promedioCamasOcupadas = '-';
				_this.rangoFecha = '-';
				if(response.body.length > 0) {
					for (let value of response.body) {
						_this.promedioCamasOcupadas = value.camasPromedioPorDia;
						_this.rangoFecha = value.cantidadDias;
					} 
				} 
			}, function(error) { 
				this.buscando = false; 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal); 
				return;
			});
		},
		getPromedioDiasInternados: function () {
			this.buscando = true;
			_this.promedioDiasInternados = '-';
			estadisticaService.getPromedioDiasInternados({fechaDesde: _this.search.fechaDesde, fechaHasta: _this.search.fechaHasta, sede: _this.search.sede, 
														idEspecialidadInternacion: _this.search.idEspecialidadInternacion, idSubEspecialidad: _this.search.idSubEspecialidad}).then(function(response) {
				_this.buscando = false;
				if(response.body.length > 0) {
					for (let value of response.body) {
						_this.promedioDiasInternados = value.promedioDiasInternados;
					} 
				} 
			}, function(error) { 
				this.buscando = false; 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal); 
				return;
			});
		},
		getDiasInternadosPorProcedimiento: function () {
			this.buscando = true;
			_this.promedioDiasInternadosPorProcedimiento = [];
			estadisticaService.getDiasInternadosPorProcedimiento({fechaDesde: _this.search.fechaDesde, fechaHasta: _this.search.fechaHasta, sede: _this.search.sede, 
																idEspecialidadInternacion: _this.search.idEspecialidadInternacion, idSubEspecialidad: _this.search.idSubEspecialidad}).then(function(response) {
				_this.buscando = false;	
				if(response.body.length > 0) {
					for (let value of response.body) {
						_this.promedioDiasInternadosPorProcedimiento.push({promedioDiasTranscurridos: value.promedioDiasTranscurridos, descripcionProcedimiento: value.descripcionProcedimiento});
					} 
				} 
			}, function(error) { 
				this.buscando = false; 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal); 
				return;
			});
		},
		getDiasInternadosHastaCirugia: function () {
			this.buscando = true;
			_this.diasInternadosHastaCirugia = "-";
			estadisticaService.getDiasInternadosHastaCirugia({fechaDesde: _this.search.fechaDesde, fechaHasta: _this.search.fechaHasta, sede: _this.search.sede, idEspecialidadInternacion: _this.search.idEspecialidadInternacion}).then(function(response) {
				_this.buscando = false;		
				if(response.body.length > 0) {
					for (let value of response.body) {
						_this.diasInternadosHastaCirugia = value.promedioDiasInternados;
					} 
				} 
			}, function(error) { 
				this.buscando = false; 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal); 
				return;
			});
		},
		getEstadisticasCama: function () {
			_this.getPromedioCamasOcupadasPorDia();
			_this.getPromedioDiasInternados();
			_this.getDiasInternadosPorProcedimiento();
			_this.getDiasInternadosHastaCirugia();
		},
		getEspecialidades: function() {
			if(_this.especialidades.length != 1)
				_this.especialidades = [];
			datosParametricosService.getEspecialidades({activoDatoParametrico: 1}).then(function(response) {					
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						if(value.activoDatoParametrico == 1) {
							_this.especialidades.push(value);
						}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getSubEspecialidades: function() {
			_this.subespecialidades = [];
			datosParametricosService.getSubEspecialidades({activoDatoParametrico: 1}).then(function(response) {					
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						if(value.activoDatoParametrico == 1) {
							_this.subespecialidades.push(value);
						}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getSedes: function() {
			_this.sedes = [{idSede:"", nombreSede:"Sede"}];
			sedeService.get({}).then(function(response) {					
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						//if(value.activoObraSocial == 1) {
							_this.sedes.push(value);
						//}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		limpiar() {
			this.search = JSON.parse(search);
			this.getEstadisticasCama();
		}
	}
}

